"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var Icon_1 = require("../../atoms/Icon/Icon");
var IconButton_1 = require("../../atoms/IconButton/IconButton");
var TextIcon_1 = require("../../atoms/TextIcon/TextIcon");
var Typography_1 = require("../../atoms/Typography/Typography");
var ExpandableSection_logic_1 = require("./ExpandableSection.logic");
/**
 * ExpandableSection molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-expandablesection--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ExpandableSection Source}
 */
var ExpandableSection = function (_a) {
    var children = _a.children, className = _a.className, icon = _a.icon, _b = _a.initiallyExpanded, initiallyExpanded = _b === void 0 ? false : _b, postTitleContent = _a.postTitleContent, _c = _a.showPostTitleContentExpanded, showPostTitleContentExpanded = _c === void 0 ? false : _c, title = _a.title, _d = _a.remainMounted, remainMounted = _d === void 0 ? false : _d, edit = _a.edit;
    var _e = (0, ExpandableSection_logic_1.useExpandableSection)({ initiallyExpanded: initiallyExpanded }), classes = _e.classes, handleTitleClick = _e.handleTitleClick, isExpanded = _e.isExpanded;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.titleContainer, isExpanded && classes.marginBottom24) }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ className: classes.button, onClick: handleTitleClick }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.chevronDown, color: theme_1.default.colors.dark, className: (0, classnames_1.default)(classes.marginRight, classes.chevron, isExpanded && classes.chevronExpanded) }), renderTitle()] })), renderEdit(), renderPostTitleContent()] })), (0, jsx_runtime_1.jsx)(core_1.Collapse, __assign({ in: isExpanded, unmountOnExit: !remainMounted }, { children: children }))] })));
    function renderTitle() {
        return icon ? ((0, jsx_runtime_1.jsx)(TextIcon_1.TextIcon, { bold: true, icon: icon, text: title, className: (0, classnames_1.default)(classes.titleWithIcon, edit && classes.titleWithIconWidthEdit), color: (0, styleUtilities_1.withOpacity)(theme_1.default.textColors.primary, 0.5), iconMargin: 'wide' })) : ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: (0, classnames_1.default)(classes.title, edit && classes.titleWidthEdit), noWrap: true, bold: true }, { children: title })));
    }
    function renderEdit() {
        if (!edit) {
            return null;
        }
        var onClick = edit.onClick, disabled = edit.disabled, tooltip = edit.tooltip;
        return ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { className: classes.editIcon, icon: icons_1.default.edit, onClick: onClick, isDisabled: disabled, tooltip: tooltip, withoutReservedPadding: true }));
    }
    function renderPostTitleContent() {
        if (showPostTitleContentExpanded || !isExpanded) {
            return postTitleContent;
        }
        return null;
    }
};
exports.ExpandableSection = ExpandableSection;
